import AllAccessIcon from 'images/subscribe-icon-all-access.svg';
import MonthlyIcon from 'images/subscribe-icon-monthly.svg';
import YpIcon from 'images/subscribe-icon-yp.svg';

import { ButtonProps } from '../components/BaseUI/Button';
import { subscribe_path } from '../routes';
import {
  DEFAULT_ANNUAL_PRICE,
  DEFAULT_MONTHLY_PRICE,
  DEFAULT_YOUNG_PROFESSIONAL_PRICE,
  DISCOUNTED_PRO_PRICE,
  NOW_ANNUAL_OFFER_CODE,
  NOW_MONTHLY_OFFER_CODE,
  NOW_PRO_OFFER_CODE,
  NOW_YP_OFFER_CODE,
} from '../src/constants';

export type planType = 'basic' | 'monthly' | 'annual' | 'pro' | 'young_professionals';

interface GenerateCardPropArgs {
  planType: planType;
  hrefParams?: { [key: string]: string };
  trackingProps?: { [key: string]: string };
}

export const generateCardProps = ({
  planType,
  hrefParams = {},
  trackingProps = {},
}: GenerateCardPropArgs) => {
  const buttonProps: ButtonProps = {
    rounded: 'full' as const,
    href: '', // assign this based on planType in switch statement below
    trackClick: Object.keys(trackingProps).length > 0,
    trackingProps,
  };
  let benefits: string[] = [];
  let icon: string;
  let price: number;
  let title: string;
  let altTitle: string;

  switch (planType) {
    case 'monthly':
    case 'basic':
      buttonProps.href = subscribe_path({ offer: NOW_MONTHLY_OFFER_CODE, ...hrefParams });
      benefits = [
        'Access to reporting',
        'Access to Profiles, Directory and Forum',
        'No access to org charts',
        'Billed every four weeks',
      ];
      icon = MonthlyIcon;
      price = DEFAULT_MONTHLY_PRICE;
      title = 'Monthly';

      if (planType === 'basic') {
        altTitle = 'Basic';
      }
      break;
    case 'annual':
      buttonProps.href = subscribe_path({ offer: NOW_ANNUAL_OFFER_CODE, ...hrefParams });
      benefits = [
        "Read stories you won't find elsewhere",
        'Subscribe to our suite of newsletters',
        'Access to Profiles, Directory and Forum',
        'Read on the go with The Information app',
      ];
      icon = AllAccessIcon;
      price = DEFAULT_ANNUAL_PRICE;
      title = 'Annual';

      break;
    case 'young_professionals':
      buttonProps.href = subscribe_path({ offer: NOW_YP_OFFER_CODE, ...hrefParams });
      benefits = [
        'Available for those 30 and under',
        'Same access as Annual',
        'Receive <span class="--red">two years of Annual access</span> at our best price',
      ];
      icon = YpIcon;
      price = DEFAULT_YOUNG_PROFESSIONAL_PRICE;
      title = 'Young Professionals';
      break;
    case 'pro':
      buttonProps.href = subscribe_path({ offer: NOW_PRO_OFFER_CODE, ...hrefParams });
      benefits = [
        'Our org chart library, updated and added to monthly',
        'Exclusive surveys and proprietary databases',
        'All of our award-winning journalism',
        'An exclusive newsletter for Pro subscribers',
        'The Information app',
      ];
      icon = AllAccessIcon;
      price = DISCOUNTED_PRO_PRICE;
      title = 'The Information Pro';
      altTitle = 'Pro';

      break;
  }

  return {
    altTitle,
    benefits,
    buttonProps,
    icon,
    price,
    title,
  };
};
